module.exports = __webpack_public_path__ + "img/charlie_welcome.1db23638.png";